import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

const TRUST_IMG =
  "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhcGFydG1lbnQlMjBidWlsZGluZyUyMHJlc2lkZW50aWFsJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MDYwMjAxN3ww&ixlib=rb-4.1.0&q=85";

export default function Trust() {
  const { t } = useI18n();
  const badges = t("trust.badges");
  return (
    <section id="trust" className="py-24 md:py-32" data-testid="section-trust">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 relative">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="hero-photo aspect-[4/5]"
          >
            <img
              src={TRUST_IMG}
              alt="Detalles arquitectónicos de un edificio residencial en Buenos Aires"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </motion.div>
          <div className="absolute -bottom-6 -right-4 md:right-8 bg-[#FAF9F6] rounded-md p-5 shadow-xl border border-slate-900/8 max-w-[260px]">
            <div className="eyebrow text-[#D97706]">ISO 27001</div>
            <p className="text-sm mt-1 leading-snug text-[#0F172A]">
              Firma digital certificada y trazabilidad completa del ciclo del proyecto.
            </p>
          </div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <div className="eyebrow">{t("trust.eyebrow")}</div>
          <h2 className="mt-4 font-serif-display text-4xl md:text-5xl leading-[1.05] tracking-tight text-[#0F172A]">
            {t("trust.title")}
          </h2>
          <div className="mt-6 prose-editorial space-y-5">
            <p>{t("trust.paragraph_1")}</p>
            <p>{t("trust.paragraph_2")}</p>
          </div>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {Array.isArray(badges) &&
              badges.map((b, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.06 }}
                  className="border border-slate-900/12 rounded-md p-5 bg-white"
                  data-testid={`trust-badge-${i}`}
                >
                  <div className="flex items-start justify-between">
                    <div className="w-2.5 h-2.5 rounded-full bg-[#D97706]" />
                    <span className="font-mono-mark text-[0.65rem] tracking-[0.3em] uppercase text-[#525866]">
                      0{i + 1}
                    </span>
                  </div>
                  <div className="font-serif-display text-xl mt-4 text-[#0F172A]">{b.title}</div>
                  <div className="text-sm text-[#525866] mt-1 leading-relaxed">{b.desc}</div>
                </motion.div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}
